var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SettingsNavigation'),_c('div',{staticClass:"max-w-screen-xl mx-auto px-6"},[_c('TeamCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }